/* eslint-disable import/no-cycle */
/* eslint-disable no-undef */
import moment from 'moment'
import api from '@utils/api'

import { generateLayoutsHtml } from '@actions/sections'

import { setNewDocument, setDocumentsList, getLabelCompleteInTree, getLabelCompleteInTreeES, downloadFile, snakeCaseString, getValueLanguageObj } from '@utils/general'

import { catalogoClass } from '@constants/seccion';
import { SET_VALUES_DOCUMENT, SET_VALUES_SECTION } from '@constants/actionType';
import { TypeDocuments } from '@constants/documents';

import {
  StatusVisible,
  AuthorizedStatusSend,
  AuthorizedStatus
} from '@constants/general'



export const getDocuments = (querys = {}) => async (_dispatch, _getState) => {
  if (!querys?.type) querys.type = 'all'
  const response = await api.getListDocuments(querys)
  // const response = {data: [{"id":14,"tipo":"DOCTO","nombre":{"es":"Estatuto Organico INAI"},"fecha_publicacion":"2021-08-27T16:46:01","estatus":"Autorizado","visible":1,"eliminado":0,"lectura":1,"id_seccion":13,"descripcion":{"es":"Estatuto Organico INAI"},"palabra":{"es":"Estatuto Organico INAI"},"contenido":{"es":"Estatuto Organico INAI.pdf"},"fecha_autorizacion":"2021-08-27T16:46:01"},{"id":15,"tipo":"DOCTO","nombre":{"es":"DOF -  modificación del Estatuto Orgánico del INAI"},"fecha_publicacion":"2021-08-27T16:54:56","estatus":"Autorizado","visible":1,"eliminado":1,"lectura":1,"id_seccion":13,"descripcion":{"es":"DOF -  modificación del Estatuto Orgánico del INAI"},"palabra":{"es":"DOF -  modificación del Estatuto Orgánico del INAI"},"contenido":{"es":"DOF -  modificación del Estatuto Orgánico del INAI.pdf"},"fecha_autorizacion":"2021-08-27T16:54:56"},{"id":18,"tipo":"DOCTO","nombre":{"es":"Estatuto Orgánico del INAI"},"fecha_publicacion":"2021-08-30T16:51:37","estatus":"Pendiente","visible":0,"eliminado":0,"lectura":1,"id_seccion":13,"descripcion":{"es":"Estatuto Orgánico del INAI"},"palabra":{"es":"Estatuto Orgánico del INAI"},"contenido":{"es":"Estatuto Organico INAI.pdf"},"fecha_autorizacion":"2021-08-30T16:51:37"}]}
  return response;
};

export const reOrderDocument = (data) => async (_dispatch, _getState) => {
  const response = await api.reOrderDocument(data)
  return response;
};

export const updateVisibilityStatus = ({ id, justification, visible }) => async (_dispatch, _getState) => {
  let validateStatus = null
  if (visible === StatusVisible.IS_VISIBLE) validateStatus = 'hide'
  if (visible === StatusVisible.IS_HIDDEN) validateStatus = 'show'
  const data = {
    status: validateStatus,
    reason: justification
  }
  const response = await api.updateVisibilityDocument(id, data)
  return response;
};
export const deleteDocument = ({ id, type, justification, selectedNavegationTree }) => async (_dispatch, getState) => {
  const { sectionTreeCurrentCatalog } = getState().catalogs
  const getRuta = getLabelCompleteInTreeES(sectionTreeCurrentCatalog, selectedNavegationTree, '' )
  const data = {
    reason: justification,
    ruta: getRuta
  }
  const response = await api.deleteDocument(id, { type }, data)
  return response;
};

export const changeStatusDocument = ({ id, justification, type }) => async (_dispatch, getState) => {
  if (!type) return false
  const { general } = getState().document
  const { sectionTreeCurrentCatalog } = getState().catalogs
  const data = {
    status: type,
    reason: justification
  }
  let querys = {}
  if (type === AuthorizedStatusSend.STATUS_AUTHORIZED ) {
    const getRuta = getLabelCompleteInTreeES(sectionTreeCurrentCatalog, general.selectedNavegationTree, '' )
    querys.ruta = getRuta
  }
  const response = await api.changeStatusDocument(id, data, querys)
  return response;
};
export const confirmDeleteDocument = ({ id, justification }) => async (_dispatch, _getState) => {
    console.log('confirmacion de Eliminar documento')
    return true;
};

export const getDocumentsListWebLanding = (_params) => async (_dispatch, _getState) => {
  const response = [{"titleSection":"Datos personales","documents":[{"publicationDate":"2021-04-10T14:53:19.847Z","name":{"es":"Política de Privacidad","en":"Política de Privacidad","pt":"Política de Privacidad"},"description":{"es":"In hac habitasse platea dictumst. Mauris elit dui, tempor at congue eget, sagittis in neque.","en":"In hac habitasse platea dictumst. Mauris elit dui, tempor at congue eget, sagittis in neque.","pt":"In hac habitasse platea dictumst. Mauris elit dui, tempor at congue eget, sagittis in neque."},"typeDocument":1,"file":null,"urlLink":"https://www.americamovil.com/Spanish/overview/default.aspx","urlTarget":"_blank","formattedText":null},{"publicationDate":"2021-04-10T14:53:19.847Z","name":{"es":"Materiales de Capacitación, Concientización y Entrenamiento","en":"Materiales de Capacitación, Concientización y Entrenamiento","pt":"Materiales de Capacitación, Concientización y Entrenamiento"},"description":{"es":"In hac habitasse platea dictumst. Mauris elit dui, tempor at congue eget, sagittis in neque.","en":"In hac habitasse platea dictumst. Mauris elit dui, tempor at congue eget, sagittis in neque.","pt":"In hac habitasse platea dictumst. Mauris elit dui, tempor at congue eget, sagittis in neque."},"typeDocument":2,"file":[],"urlLink":null,"urlTarget":null,"formattedText":null},{"publicationDate":"2021-04-10T14:53:19.847Z","name":{"es":"Legislación y Guías Émitidas por la Autoridad","en":"Legislación y Guías Émitidas por la Autoridad","pt":"Legislación y Guías Émitidas por la Autoridad"},"description":{"es":"In hac habitasse platea dictumst. Mauris elit dui, tempor at congue eget, sagittis in neque.","en":"In hac habitasse platea dictumst. Mauris elit dui, tempor at congue eget, sagittis in neque.","pt":"In hac habitasse platea dictumst. Mauris elit dui, tempor at congue eget, sagittis in neque."},"typeDocument":3,"file":[],"urlLink":null,"urlTarget":null,"formattedText":{"es":"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.","en":"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.","pt":"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."}}]}]
  return response;
};

export const setDynamicDocumentsList = (layoutByLanguage) => async (dispatch, getState) => {
  const response = await dispatch(getDocumentsListWebLanding())

  const newLayouts = await layoutByLanguage.map(async (layout) => {
    const newLayout =  await setDocumentsList({
      html: layout.html,
      language: layout.language,
      data: response
    })
    return { ...layout, html: newLayout }
  })
  const resolvePromise = await  Promise.all(newLayouts)

  await dispatch({
    type: SET_VALUES_SECTION,
    payload: { layoutsHtml: resolvePromise }
  })

  return layoutByLanguage
};

export const addDocuemntToHtmlGenerate = () => async (dispatch, getState) => {
  const { document } = getState()
  const componentsAvailables = catalogoClass.filter((item => item.parentClass.class !== 'sct-category'))

  const layoutByLanguage = await dispatch(generateLayoutsHtml({
    componentsAvailables,
    componentsSelected: [catalogoClass[0]]
  }))
  const newLayouts = await layoutByLanguage.map(async (layout) => {
    const newLayout =  await setNewDocument({
      html: layout.html,
      language: layout.language,
      state: document
    })
    return { ...layout, html: newLayout }
  })

  const resolvePromise = await  Promise.all(newLayouts)

  await dispatch({
    type: SET_VALUES_DOCUMENT,
    payload: { layoutsHtml: resolvePromise }
  })

  return resolvePromise;
};

export const addDocument = (estatus) => async (_dispatch, getState) => {
  const { general, content, obligatory } = getState().document
  const { keysLanguageCatalog, workstationsCurrentCatalog, sectionTreeCurrentCatalog } = getState().catalogs
  const getRuta = getLabelCompleteInTreeES(sectionTreeCurrentCatalog, general.selectedNavegationTree, '' )

  if (!estatus) return false

  const formData = new FormData()
  const data = {
    "id_seccion": general.selectedNavegationTree,
    "ruta": getRuta,
    estatus,
    // "fecha_publicacion": new Date(general.publicationDate),
    "visible": estatus === AuthorizedStatusSend.STATUS_AUTHORIZED ? StatusVisible.IS_VISIBLE : StatusVisible.IS_HIDDEN,
    "nombre": {},
    "descripcion": {},
    "palabra": {},
    "tipo": "",
    "contenido": null,
    "lectura": obligatory.mandatoryReading ? 1 : 0,
    "puestos": [],
  }

  keysLanguageCatalog.map(key => {
      data.nombre[key] = general[key].name
      data.descripcion[key] = general[key].description
      data.palabra[key] = general[key].keywords
  })

  if(general.typeDocument === TypeDocuments.IS_LINK ) {
    data.tipo = "URL"
    data.contenido = { url: content.link.url, target: content.link.target }
  }
  if(general.typeDocument === TypeDocuments.IS_DOCUMENT_PDF ) {
    data.tipo = "DOCTO"
    data.contenido = {}
    keysLanguageCatalog.map(key => {
      if (content.document[key].file[0]?.fileName) {
        data.contenido[key] = content.document[key].file[0]?.fileName
        formData.append('files', content.document[key].file[0].file)
      }
    })
  }
  if(general.typeDocument === TypeDocuments.IS_FORMATTED_TEXT ) {
    data.tipo = "HTML"
    data.contenido = {}
    keysLanguageCatalog.map(key => {
      if (content.formattedText[key]?.description) {
        data.contenido[key] = content.formattedText[key].description
      }
    })
  }

  // if (obligatory.isAllWorstation) { // Se validan los puestos dinamicamente
  //   data.puestos = workstationsCurrentCatalog.map(item => item.id)
  // } else {
  //   data.puestos = obligatory.workstationSelected.map(item => item.id)
  // }

  if (obligatory.mandatoryReading) { // Si es mandatory entoces se busca todo aquel que coincida con director
    const getPuestosLikeDirector = workstationsCurrentCatalog.filter(item => item.id.toLowerCase().includes("director".toLowerCase()))
    if (getPuestosLikeDirector.length) {
      data.puestos = getPuestosLikeDirector.map(item => item.id )
    }
  }

  formData.append('content', JSON.stringify(data))
  const response = await api.addDocument(formData)
  return response
};

export const getDetailDocument = ({ id, setToState = true}) => async (dispatch, getState) => {
    const response = await api.getDetailDocument(id)
    if (!response.status && setToState) return dispatch(setDetailDocument(response.data))
    return response
  };

  export const getOnlyDetailDocument = (id, errorModal) => async (dispatch, getState) => {
    const response = await api.getDetailDocument(id, errorModal)
    return response
  };

  export const deleteFile = (data,errorModal) => async (_dispatch, _getState) => {
    const response = await api.deleteFile(data,errorModal)
    return response;
  };

  export const renameDirDocument = (data) => async (_dispatch, _getState) => {
    const response = await api.renameDirDocument(data)
    return response;
  };

  export const setDetailDocument = ({
    id,
    nombre,
    descripcion,
    palabra,
    fecha_publicacion,
    tipo,
    lectura,
    puestos = [],
    contenido,
    id_seccion,
    estatus,
    id_original
  }) => async (dispatch, getState) => {
    const { catalogs } = getState()
    const keysLenguages = catalogs.keysLanguageCatalog
    const workstationCatalog = catalogs.workstationsCurrentCatalog

    const isAllWorstation = workstationCatalog.length === puestos.length
    const workstationSelected = []
    const workstationAvailable = []
    if (!isAllWorstation) {
      workstationCatalog.map((item) => {
        const isSelectWorkStation = puestos.find(id => id === item.id)
        if (isSelectWorkStation) workstationSelected.push(item)
        else workstationAvailable.push(item)
        return item
      })
    }
    let validateType = ''
    if (tipo === "URL") validateType = TypeDocuments.IS_LINK
    if (tipo === "DOCTO") validateType = TypeDocuments.IS_DOCUMENT_PDF
    if (tipo === "HTML") validateType = TypeDocuments.IS_FORMATTED_TEXT

    const state = {
      general: {
        publicationDate: new Date(fecha_publicacion),
        typeDocument: validateType,
        selectedNavegationTree: id_seccion
      },
      obligatory: {
        mandatoryReading: !!lectura,
        workstationAvailable,
        workstationSelected,
        isAllWorstation
      },
      id,
      estatus,
      id_original,
      // visibility: {
      //   optionCountry: visibility,
      //   isAllCountriesVisible
      // },
      content: {}
    }

    keysLenguages.map((language) => {
      const getName = nombre[language] || ''
      const getDescription = descripcion[language] || ''
      const getKeywords = palabra[language] || ''
      state.general[language] = { name: getName, description: getDescription, keywords: getKeywords}
    })
    if (validateType === TypeDocuments.IS_LINK) {
      state.content =  {
        link: {
          url: contenido.url,
          target: contenido.target
        }
      }
    }
    else if (validateType === TypeDocuments.IS_DOCUMENT_PDF) {
      state.prevContentDoc  = {
        ...contenido
      }
      // keysLenguages.map((language) => {
      //   const getFile = file[language] || []
      //   state.content  = { 
      //     document: {
      //       ...state.content.document, [language]: { file: getFile}
      //     }
      //   }
      // })
    } 
    else if (validateType === TypeDocuments.IS_FORMATTED_TEXT) {
      keysLenguages.map((language) => {
        const getDescription = contenido[language] || ''
        state.content = {
          formattedText : {...state.content.formattedText, [language] : { description: getDescription} }
        }
      })
    }

    dispatch({
      type: SET_VALUES_DOCUMENT,
      payload: {
        ...state
      },
    });

  };

export const updateDocument = () => async (_dispatch, getState) => {
  const { general, content, obligatory, id, prevContentDoc, estatus } = getState().document
  const { keysLanguageCatalog, workstationsCurrentCatalog, sectionTreeCurrentCatalog } = getState().catalogs
  // const getRuta = getLabelCompleteInTree(sectionTreeCurrentCatalog, general.selectedNavegationTree, '' )
  const getRuta = getLabelCompleteInTreeES(sectionTreeCurrentCatalog, general.selectedNavegationTree, '' )
  const formData = new FormData()
  const data = {
    "id_seccion": general.selectedNavegationTree,
    "ruta": getRuta,
    id,
    // "fecha_publicacion": new Date(general.publicationDate),
    "nombre": {},
    "descripcion": {},
    "palabra": {},
    "tipo": "",
    "contenido": null,
    "lectura": obligatory.mandatoryReading ? 1 : 0,
    "puestos": [],
  }
  console.log('data', data)

  keysLanguageCatalog.map(key => {
    data.nombre[key] = general[key].name
    data.descripcion[key] = general[key].description
    data.palabra[key] = general[key].keywords
  })

  if(general.typeDocument === TypeDocuments.IS_LINK ) {
    data.tipo = "URL"
    data.contenido = { url: content.link.url, target: content.link.target }
  }
  if(general.typeDocument === TypeDocuments.IS_DOCUMENT_PDF ) {
    data.tipo = "DOCTO"
    data.contenido = prevContentDoc || {}
    keysLanguageCatalog.map(key => {
      if (content?.document?.[key].file[0]?.fileName) {
        let nameDoc = content.document[key].file[0]?.fileName
        //if ( estatus === AuthorizedStatus.STATUS_AUTHORIZED ) {
          let [name, extension] = content.document[key].file[0]?.fileName.split(".")
          nameDoc = `${name}_edit.${extension}`
        // }
        data.contenido[key] = nameDoc
        formData.append('files', content.document[key].file[0].file,nameDoc)
      }
    })
  }
  if(general.typeDocument === TypeDocuments.IS_FORMATTED_TEXT ) {
    data.tipo = "HTML"
    data.contenido = {}
    keysLanguageCatalog.map(key => {
      if (content.formattedText[key]?.description) {
        data.contenido[key] = content.formattedText[key].description
      }
    })
  }

  // if (obligatory.isAllWorstation) {
  //   data.puestos = workstationsCurrentCatalog.map(item => item.id)
  // } else {
  //   data.puestos = obligatory.workstationSelected.map(item => item.id)
  // }

  if (obligatory.mandatoryReading) { // Si es mandatory entoces se busca todo aquel que coincida con director
    const getPuestosLikeDirector = workstationsCurrentCatalog.filter(item => item.id.toLowerCase().includes("director".toLowerCase()))
    if (getPuestosLikeDirector.length) {
      data.puestos = getPuestosLikeDirector.map(item => item.id )
    }
  }

  formData.append('content', JSON.stringify(data))
  const response = await api.updateDocument(formData)
  return response
};

export const getInfoForPreviewDocument = (language) => async (_dispatch, getState) => {
  const { document } = getState()
  const { general, content } = document
  const data = {
    "nombre_seccion": general[language].name,
    "secciones_padre": general.selectedLabelNavegationTree,
    "language": language,
    "paises": [
      {
        "nombre": {
          "es": "Mexico"
        },
        "seleccionado": true
      }
    ],
    "categoria": [
      {
        "nombre": {
          "es": "Para Candidatos"
        },
        "seleccionado": true
      },
      {
        "nombre": {
          "es": "Todos"
        },
        "seleccionado": false
      }
    ],
    "subCategoria": [
      {
        "nombre": {
          "es": "Candidato tipo 1"
        },
        "seleccionado": true
      },
      {
        "nombre": {
          "es": "Candidato tipo 2"
        },
        "seleccionado": false
      },
      {
        "nombre": {
          "es": "Candidato tipo 3"
        },
        "seleccionado": false
      }
    ],
    "documentos": []
  }

  // const getOtherDocuments = []

  const newDocument = {
    "nombre": general[language].name,
    "descripcion": general[language].description,
    "tipo": "",
    "contenido": {}
  }
  if(general.typeDocument === TypeDocuments.IS_LINK ) {
    newDocument.tipo = "URL"
    newDocument.contenido = { url: content.link.url, target: content.link.target }
  }
  if(general.typeDocument === TypeDocuments.IS_DOCUMENT_PDF ) {
    newDocument.tipo = "DOCTO"
    newDocument.contenido = []
  }
  if(general.typeDocument === TypeDocuments.IS_FORMATTED_TEXT ) {
    newDocument.tipo = "HTML"
    newDocument.contenido = []
    newDocument.contenido.push({[language]: content.formattedText[language].description})
  }
  data.documentos.push(newDocument)
  console.log("data", data)
  return true;
};
export const rejectDocument = ({ justification }) => async (_dispatch, _getState) => {
  console.log('rechazar documento')
  return true;
};
export const deleteVersion = ({ justification }) => async (_dispatch, _getState) => {
  console.log('Eliminar version documento')
  return true;
};

export const getReportByDocument = (_params) => async (_dispatch, _getState) => {
  const response = {"data":[{"fi_id":1003,"country":"MEXICO","fc_nombre":"Edgar Ceron","fc_correo":"test@globalhitss.com","fi_nombre_empresa":"Global Hitss","fc_puesto_id":1,"fc_fecha_lectura":"2021-04-10T14"},{"fi_id":1003,"country":"MEXICO","fc_nombre":"Edgar Ceron","fc_correo":"test@globalhitss.com","fi_nombre_empresa":"Global Hitss","fc_puesto_id":2,"fc_fecha_lectura":"2021-01-15T14"},{"fi_id":1003,"country":"MEXICO","fc_nombre":"Edgar Ceron","fc_correo":"test@globalhitss.com","fi_nombre_empresa":"Global Hitss","fc_puesto_id":1,"fc_fecha_lectura":"2021-12-23T14"},{"fi_id":1003,"country":"MEXICO","fc_nombre":"Edgar Ceron","fc_correo":"test@globalhitss.com","fi_nombre_empresa":"Global Hitss","fc_puesto_id":2,"fc_fecha_lectura":"2021-08-21T14"},{"fi_id":1003,"country":"MEXICO","fc_nombre":"Edgar Ceron","fc_correo":"test@globalhitss.com","fi_nombre_empresa":"Global Hitss","fc_puesto_id":1,"fc_fecha_lectura":"2021-04-10T14"},{"fi_id":1003,"country":"MEXICO","fc_nombre":"Edgar Ceron","fc_correo":"test@globalhitss.com","fi_nombre_empresa":"Global Hitss","fc_puesto_id":1,"fc_fecha_lectura":"2021-04-10T14"},{"fi_id":1003,"country":"MEXICO","fc_nombre":"Edgar Ceron","fc_correo":"test@globalhitss.com","fi_nombre_empresa":"Global Hitss","fc_puesto_id":1,"fc_fecha_lectura":"2021-04-10T14"},{"fi_id":1003,"country":"MEXICO","fc_nombre":"Edgar Ceron","fc_correo":"test@globalhitss.com","fi_nombre_empresa":"Global Hitss","fc_puesto_id":1,"fc_fecha_lectura":"2021-04-10T14"}],"total":50}
  return response;
};

export const getListAnexos = (ruta = '') => async (_dispatch, _getState) => {
  if (!ruta) ruta = 'Procesos/Anexos'
  const response = await api.getListAnexos({ruta})
  return response;
};

export const updateAnexo = ({fullPath, name, documentFile}) => async (_dispatch, _getState) => {
  const querys = {
    ruta: fullPath
  }
  const formData = new FormData()

  formData.append('files', documentFile[0].file ,name)

  const response = await api.simpleUpload(formData, querys)
  return response;
};

export const getReportTotalUsersReaders = (idDocument, querys) => async (_dispatch, _getState) => {
  const response = await api.getReportTotalUsersReaders(idDocument, querys)
  return response;
};

export const getReportDetailUsersReaders = (idDocument, querys) => async (_dispatch, _getState) => {
  const response = await api.getReportDetailUsersReaders(idDocument, querys)
  return response;
};
export const getReportDetailUsersReadersDownload = (idDocument, nameDocument, querys) => async (_dispatch, _getState) => {
  const response = await api.getReportDetailUsersReadersDownload(idDocument, querys)
  if (!response?.status) {
    const formatName = nameDocument && getValueLanguageObj(nameDocument).slice(0,15)
    downloadFile(response.data, `${snakeCaseString(formatName)}_${moment().locale('es').format('DDMMYYYY')}.xlsx`)
  }
  return response;
};

export const getPuestosDocument = (data) => async (_dispatch, _getState) => {
  const response = await api.getPuestosDocument(data)
  return response;
}
